// @ts-nocheck
const ENV = process.env.REACT_APP_ENTORNO || 'testing';

export const ALIASES_PER_PAGE = 10;

export const URL_API_SIA = process.env.REACT_APP_URL_API_SIA || (
  ENV === 'production'
    ? "https://api-sia.frba.utn.edu.ar"
    : "https://api-sia-tst.frba.utn.edu.ar"
);

export const URL_KEYCLOAK = process.env.REACT_APP_URL_KEYCLOAK || (
  ENV === 'production'
    ? "https://auth.frba.utn.edu.ar/"
    : "https://auth-tst.frba.utn.edu.ar/"
);

export const REALM_KEYCLOAK = process.env.REACT_APP_URL_KEYCLOAK_REALM || (
  ENV === 'production'
    ? "FRBA"
    : "frba"
);

export const RUTA_API_ALIAS = URL_API_SIA + "/alias";

export const RUTA_API_RECIBOS = URL_API_SIA + "/recibos";

export const RUTA_API_LDAP = URL_API_SIA + "/ldap";

export const RUTA_API_USUARIOS = URL_API_SIA + "/users";

export const RUTA_API_SUELDOS = URL_API_SIA + "/sueldos";

export const ACCESO_DIFUSIONES = ["ROLE_MODULO_DIFUSIONES"];

export const ACCESO_SUELDOS = ["ROLE_MODULO_SUELDOS"]

export const ACCESO_HISTORICO_SUELDOS = ["ROLE_HISTORICO_SUELDOS"]

export const ACCESO_USUARIOS = ["ROLE_MODULO_USUARIOS"];

export const ACCESO_VPN = ["ROLE_MODULO_VPN"];

export const ACCESO_WIFI_PRIVADO = ["ROLE_MODULO_WIFI_PRIVADO"];

export const ACCESO_ALIAS = ["ROLE_MODULO_ALIAS"];

export const ACCESO_BUSCADOR_INTERNOS = ["ROLE_MODULO_BUSCADOR_INTERNOS"];

export const ACCESO_RECIBOS = ["ROLE_MODULO_RECIBOS"];

export const ACCESO_CREDENCIAL = ["ROLE_MODULO_CREDENCIAL"];

export const ACCESO_AREAS = ["ROLE_MODULO_AREAS"];

export const ACCESO_AGENDA = ["ROLE_MODULO_AGENDA"];

export const ACCESO_TRADUCTOR = ["ROLE_MODULO_TRADUCTOR"];

export const ACCESO_ADMIN_TRADUCCIONES = ["ROLE_ADMIN_TRADUCCIONES"];

export const ACCESO_VER_ROLES = ["ROLE_MODULO_VER_ROLES"];

export const ACCESO_ALTA_USUARIOS = ["ROLE_MODULO_ALTA_USUARIOS"];
export const ACCESO_CREAR_CHATBOT = ["ROLE_CREAR_CHATBOT"];
export const ACCESO_MODIFICAR_CHATBOT = ["ROLE_MODIFICAR_CHATBOT"];

export const ACCESO_ELIMINAR_CHATBOT = ["ROLE_ELIMINAR_CHATBOT"];


export const SIZE_MD = 900;

export const EMAILS_PER_PAGE = 10;

export const AREA_WIFI = "AREA_WIFI_DEF";

export const RUTA_API_DIFUSIONES = URL_API_SIA + "/difusiones";

export const RUTA_API_AREAS = URL_API_SIA + "/areas";

export const RUTA_API_TRADUCCIONES = URL_API_SIA + "/traducciones";

export const RUTA_API_CREDENCIAL = URL_API_SIA + "/credencial";

export const RUTA_API_CONSTANCIA = URL_API_SIA + "/constancia";

export const CLIENTID_KEYCLOAK = "sinap";

export const SECRET_KEY = "SguF&YSWE2gCr5GiL$f7%hwFd8dqffnCH2!IIdCMYhcK^VY4Ft";

export const EXTENSION_MAIL_INSTITUCIONAL = "@frba.utn.edu.ar";

export const HP_medrano = 16;
export const HP_campus = 26;
export const HP_APP = 21;
export const HP_sysgestion = 41;
export const HP_sysadmin = 31;
export const HP_SCI = 36;
export const OPCION_sysgestion = 1;
export const OPCION_sysadmin = 2;
export const OPCION_SCI = 3;

export const MAX_SIZE_FILE = 2097152;
export const MAX_SIZE_FILES = 5242880;
export const MAX_SIZE_FILES_osticket = 1048576;
export const FILES_PERMITIDOS =
  "image/jpg , image/png , image/jpeg , .txt , .pdf , .zip  ,.docx, .xlsx , .pptx, application/pdf ," +
  " application/zip ,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation" +
  ",application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/plain";
